import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

// import PrivateRoute from './../components/private-route.component';

import ManageAccountPage from "./../pages/account/manage/ManageAccountPage";
import AccountDashboardPage from "./../pages/account/dashboard/AccountDashboardPage";
import TrainingPage from "./../pages/training/Training";
import AdminDashboardPage from "./../pages/admin/AdminDashboardPage";
import AdminDashboardShowUserPage from "./../pages/admin/manage/users/AdminDashboardShowUserPage";
import AdminDashboardShowTopicPage from "./../pages/admin/manage/topics/AdminDashboardShowTopicPage";
import AdminDashboardShowTaskPage from "./../pages/admin/manage/topics/AdminDashboardShowTaskPage";
import ImpressPage from "./../pages/impress/ImpressPage";
import NotFoundPage from "./../pages/error/NotFoundPage";
import MarkdownCheatsheetPage from "./../pages/documentation/MarkdownCheatsheetPage";
import DocumentationListPage from "./../pages/documentation/DocumentationListPage";

export default function MainRouter({ onSessionStateChange, isAdmin }) {
  return (
    <>
      <Switch>
        <Route exact path="/">
          <Redirect to="/account/dashboard/" />
        </Route>

        <Route path="/account/manage/" component={ManageAccountPage} />

        <Route path="/account/dashboard/" component={AccountDashboardPage} />

        <Route path="/training/topic/:id/:task?" component={TrainingPage} />

        {/* ADMINNNNN */}
        <Route
          path="/admin-dashboard/overview/"
          render={() =>
            isAdmin === null ? null : isAdmin ? (
              <AdminDashboardPage />
            ) : (
              <Redirect to="/account/dashboard/" />
            )
          }
        />

        <Route
          path="/admin-dashboard/accounts/:userId"
          render={() =>
            isAdmin === null ? null : isAdmin ? (
              <AdminDashboardShowUserPage />
            ) : (
              <Redirect to="/account/dashboard/" />
            )
          }
        />

        <Route
          path="/admin-dashboard/topics/:id/tasks/:taskId"
          render={() =>
            isAdmin === null ? null : isAdmin ? (
              <AdminDashboardShowTaskPage />
            ) : (
              <Redirect to="/account/dashboard/" />
            )
          }
        />

        <Route
          path="/admin-dashboard/topics/:id"
          render={() =>
            isAdmin === null ? null : isAdmin ? (
              <AdminDashboardShowTopicPage />
            ) : (
              <Redirect to="/account/dashboard/" />
            )
          }
        />

        <Route
          path="/documentation/markdown/"
          component={MarkdownCheatsheetPage}
        />

        <Route path="/documentation/" exact component={DocumentationListPage} />

        <Route path="/impress/" component={ImpressPage} />

        <Route path="*">
          <NotFoundPage onLogout={() => onSessionStateChange(false)} />
        </Route>
      </Switch>
    </>
  );
}
